import { withRouter } from 'react-router-dom';
import BaseItens from '../../base/testes/BaseItens';

class Itens extends BaseItens {

}

export default withRouter(Itens);
